import Promise from 'bluebird';
import React, { useContext } from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';
import globalApps from '@bingads-webui-clientcenter/global-apps';

// Since there's not a way of appending to I18nModel right now
// using this method. Will talk with yuzhong about support for this
const getData = i18n => i18n.p$data.value().resource.data;

export const mergeI18n = (childI18n, parentI18n) => {
  if (childI18n && parentI18n) {
    Object.assign(getData(childI18n), getData(parentI18n));
    return childI18n;
  }
  return parentI18n;
};

/* This is to merge the parent and child i18n(App and Feature) */
export const withMergedI18n = (Component, childI18n, setGlobalAppsI18n = false) => {
  const HoC = (props) => {
    const parentI18n = useContext(I18nContext) || props.i18n;
    const i18n = mergeI18n(childI18n, parentI18n);
    if (setGlobalAppsI18n) {
      globalApps.i18n = i18n;
    }
    return (
      <I18nContext.Provider value={i18n}>
        <Component {...props} i18n={i18n} />
      </I18nContext.Provider>);
  };

  HoC.propTypes = {
    i18n: PropTypes.shape({}),
  };

  HoC.defaultProps = {
    i18n: undefined,
  };

  HoC.displayName = `WithI18n(${getDisplayName(Component)})`;

  return HoC;
};

export function loadPageWebpack({
  importFeature = _.noop,
  importL10n = _.noop,
}) {
  return Promise.all([
    importL10n(),
    importFeature(),
  ]).then(([{ default: i18n } = {}, Feature]) => ({ default: withMergedI18n(Feature, i18n, true) }));
}

export const getDefaultExport = e => e.default;
